<template>
  <div class="blik-button-copy" @click="saveToBuffer(value)">
    <slot />
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.5 2.25V0H6.875C6.26562 0 5.75 0.515625 5.75 1.125V7.875C5.75 8.48438 6.26562 9 6.875 9H11.375C11.9844 9 12.5 8.48438 12.5 7.875V3H10.25C9.82812 3 9.5 2.67188 9.5 2.25ZM10.25 0V2.25H12.5L10.25 0ZM5 8.25V3H1.625C1.01562 3 0.5 3.51562 0.5 4.125V10.875C0.5 11.4844 1.01562 12 1.625 12H6.125C6.73438 12 7.25 11.4844 7.25 10.875V9.75H6.5C5.67969 9.75 5 9.07031 5 8.25Z"
        fill="#7f8fa4" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    saveToBuffer(value) {
      this.$copyText(value);
    },
  },
};
</script>

<style lang="scss">
.blik-button-copy {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  cursor: pointer;
  border-color: transparent;

  path {
    fill: #7f8fa4;
    transition: fill 0.3s;
  }

  &:hover {
    path {
      fill: #0020ff;
    }
  }

  &:active {
    path {
      fill: #001acc;
    }
  }
}
</style>
